package at.apa.statistictracker.data.model.userproperty

import at.apa.statistictracker.data.model.statisticevent.MpsStatisticEvent
import at.apa.statistictracker.data.model.statisticevent.StatisticEvent
import at.apa.statistictracker.logger.Logger
import kotlin.js.JsExport

@JsExport
sealed class MpsUserProperty : UserProperty() {

    override fun applyToEvent(event: StatisticEvent) {
        if (event is MpsStatisticEvent) {
            when (this) {
                is UPFreeDaysActive -> event.upFreedaysActive = this.freeDaysActive
                is UPLoggedIn -> event.upLoggedIn = this.loggedIn
                is UPRegion -> event.upRegion = this.region
            }
        } else {
            Logger.w(
                TAG,
                "Cannot apply user property to passed event because it is not of type MpsStatisticEvent"
            )
        }
    }

    data class UPRegion(val region: String) : MpsUserProperty()
    data class UPLoggedIn(val loggedIn: Boolean) : MpsUserProperty()
    data class UPFreeDaysActive(val freeDaysActive: Boolean) : MpsUserProperty()
    // UP-Platform does not change for an installed app, therefore the attribute platform is set directly in the MpsStatisticEvent

    companion object {
        private const val TAG = "MpsUserProperty"
    }
}